const SKIO_BB_API_URL = 'https://api.skio.com/storefront-http/get-dynamic-box';

const SKIO_BB_STOREFRONT_TOKEN = '9b780b8834e3dc4ae1a0a1b30c3faace';

class SkioBundleBox {
  static gidToId(gid) {
    if (gid == null) return null;
    var m = String(gid).match(/\d+$/);
    return m ? m[0] : String(gid);
  }

  static roundCents(amount) {
    return Math.round((Number(amount) || 0) * 100) / 100;
  }

  static applyPercentOff(amount, percent) {
    var cents = Math.round((Number(amount) || 0) * 100);
    var discountCents = Math.floor((cents * (Number(percent) || 0)) / 100);
    return (cents - discountCents) / 100;
  }

  static formatMoney(amount) {
    var n = SkioBundleBox.roundCents(amount);
    return '$' + n.toFixed(2);
  }

  static escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  static fillTemplate(str, vars) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : m;
    });
  }

  static reinitLoox() {
    document.querySelectorAll('script[src*="loox" i]').forEach((old) => {
      var fresh = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) {
        fresh.setAttribute(old.attributes[i].name, old.attributes[i].value);
      }
      old.parentNode.insertBefore(fresh, old.nextSibling);
    });
  }

  static normalizeBox(raw) {
    var dynamicBox = raw && raw.DynamicBox;
    if (!dynamicBox) return null;

    var sizeRange = dynamicBox.sizeRange || [1, null];
    var sizeMin = Number(sizeRange[0]) || 1;
    var sizeMax = sizeRange[1] != null ? Number(sizeRange[1]) : null;

    var tierMap = dynamicBox.percentDiscountTier || {};
    var tiers = Object.keys(tierMap)
      .map(function (k) {
        return { qty: Number(k), percent: Number(tierMap[k]) || 0 };
      })
      .sort(function (a, b) {
        return a.qty - b.qty;
      });

    function mapVariantGroup(v) {
      return {
        productId: SkioBundleBox.gidToId(v.productPlatformId),
        title: v.productTitle || '',
        fallbackImage: v.productImageSrc || null,
        variants: (v.productVariants || []).map(function (pv) {
          return {
            id: SkioBundleBox.gidToId(pv.platformId),
            title: pv.productVariantTitle || '',
            price: Number(pv.price) || 0,
            compareAtPrice: Number(pv.compareAtPrice) || 0,
            image: pv.imageSrc || v.productImageSrc || null,
          };
        }),
      };
    }

    var products = (dynamicBox.selectableProductVariants || []).map(mapVariantGroup);
    var upsells = (dynamicBox.oneTimeUpsells || []).map(mapVariantGroup);

    var sellingPlans = Object.keys(dynamicBox.sellingPlanGroup || {}).map(function (groupId) {
      var g = dynamicBox.sellingPlanGroup[groupId];
      var variantMapping = {};
      Object.keys(g.variantMapping || {}).forEach(function (variantGid) {
        var m = g.variantMapping[variantGid];
        variantMapping[SkioBundleBox.gidToId(variantGid)] = {
          planId: SkioBundleBox.gidToId(m.planId),
          adjustedPrice: Number(m.adjustedPrice),
        };
      });
      return {
        groupId: groupId,
        planId: SkioBundleBox.gidToId(groupId),
        title: g.title || 'Subscribe & Save',
        priceAdjustmentAmount: Number(g.priceAdjustmentAmount) || 0,
        priceAdjustmentType: g.priceAdjustmentType || 'PERCENTAGE',
        variantMapping: variantMapping,
      };
    });

    var settings = dynamicBox.settings || {};
    var categoryOrder = settings.productGroupingOrder || [];
    var grouping = settings.productGrouping || {};
    var categorized = categoryOrder.length > 0;
    var categories = [];

    if (categorized) {
      var byCategory = {};
      products.forEach(function (product) {
        var matches = categoryOrder.filter(function (cat) {
          return (grouping[cat] || []).indexOf(product.productId) !== -1;
        });
        var cats = matches.length ? matches : ['Other'];
        cats.forEach(function (cat) {
          if (!byCategory[cat]) byCategory[cat] = [];
          byCategory[cat].push(product);
        });
      });
      var order = categoryOrder.concat(byCategory.Other ? ['Other'] : []);
      categories = order
        .filter(function (cat) {
          return byCategory[cat] && byCategory[cat].length;
        })
        .map(function (cat) {
          return { name: cat, products: byCategory[cat] };
        });
    }

    return {
      boxId: dynamicBox.boxId,
      sizeMin: sizeMin,
      sizeMax: sizeMax,
      tiers: tiers,
      products: products,
      upsells: upsells,
      sellingPlans: sellingPlans,
      categorized: categorized,
      categories: categories,
    };
  }

  constructor(root) {
    this.root = root;
    this.config = this.readConfig();
    this.box = null;
    this.selection = new Map(); // variantId -> { qty, variant, product }
    this.upsellSelection = new Map(); // variantId -> { qty, variant, product }
    this.subscribe = true; // defaults to Subscribe & Save, per merchant request
    this.selectedPlanGroupId = null;
    this.step = 1;
    this.cardSyncers = [];
    this.upsellCardSyncers = [];
    this.ratingEls = new Map(); // productId -> the card's .skio-bb__card-rating wrapper

    this.els = {
      loading: root.querySelector('[data-skio-bb-loading]'),
      error: root.querySelector('[data-skio-bb-error]'),
      retry: root.querySelector('[data-skio-bb-retry]'),
      content: root.querySelector('[data-skio-bb-content]'),
      tabs: root.querySelector('[data-skio-bb-tabs]'),
      grid: root.querySelector('[data-skio-bb-grid]'),
      upsellsGrid: root.querySelector('[data-skio-bb-upsells-grid]'),
      panel1: root.querySelector('[data-skio-bb-panel="1"]'),
      panel2: root.querySelector('[data-skio-bb-panel="2"]'),
      summary: root.querySelector('[data-skio-bb-summary]'),
      summaryHeading: root.querySelector('[data-skio-bb-summary-heading]'),
      drawerHandle: root.querySelector('[data-skio-bb-drawer-handle]'),
      drawerClose: root.querySelector('[data-skio-bb-drawer-close]'),
      drawerBackdrop: root.querySelector('[data-skio-bb-drawer-backdrop]'),
      scales: [root.querySelector('[data-skio-bb-scale]'), root.querySelector('[data-skio-bb-scale-mobile]')].filter(Boolean),
      tierMessages: [root.querySelector('[data-skio-bb-tier-message]'), root.querySelector('[data-skio-bb-tier-message-mobile]')].filter(
        Boolean
      ),
      freeShippings: [
        root.querySelector('[data-skio-bb-free-shipping]'),
        root.querySelector('[data-skio-bb-free-shipping-mobile]'),
      ].filter(Boolean),
      mobileStatus: root.querySelector('[data-skio-bb-mobile-status]'),
      itemsDivider: root.querySelector('[data-skio-bb-items-divider]'),
      cartItems: root.querySelector('[data-skio-bb-cart-items]'),
      subscription: root.querySelector('[data-skio-bb-subscription]'),
      totals: root.querySelector('[data-skio-bb-totals]'),
      continueBtn: root.querySelector('[data-skio-bb-continue]'),
      backBtn: root.querySelector('[data-skio-bb-back]'),
      checkoutBtn: root.querySelector('[data-skio-bb-checkout]'),
      cartError: root.querySelector('[data-skio-bb-cart-error]'),
      mobileBar: root.querySelector('[data-skio-bb-mobile-bar]'),
      mobileBarOpen: root.querySelector('[data-skio-bb-mobile-bar-open]'),
      mobileBarProgress: root.querySelector('[data-skio-bb-mobile-bar-progress]'),
      mobileBarMeta: root.querySelector('[data-skio-bb-mobile-bar-meta]'),
      mobileBarTotal: root.querySelector('[data-skio-bb-mobile-bar-total]'),
      mobileBarCheckout: root.querySelector('[data-skio-bb-mobile-bar-checkout]'),
    };

    this.bindStaticEvents();
    this.load();
  }

  readConfig() {
    var el = this.root.querySelector('[data-skio-bb-config]');
    try {
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  }

  strings() {
    return this.config.strings || {};
  }

  bindStaticEvents() {
    if (this.els.retry) this.els.retry.addEventListener('click', () => this.load());
    if (this.els.backBtn) this.els.backBtn.addEventListener('click', () => this.goToStep(1));
    if (this.els.continueBtn) {
      this.els.continueBtn.addEventListener('click', () => {
        if (this.els.continueBtn.disabled) return;
        if (this.box.upsells.length === 0) {
          this.checkout();
        } else {
          this.goToStep(2);
        }
      });
    }
    if (this.els.checkoutBtn) this.els.checkoutBtn.addEventListener('click', () => this.checkout());

    if (this.els.mobileBar) this.els.mobileBar.addEventListener('click', () => this.openDrawer());
    if (this.els.mobileBarCheckout) {
      this.els.mobileBarCheckout.addEventListener('click', (e) => {
        e.stopPropagation();
        if (this.box.upsells.length === 0) {
          this.checkout();
        } else {
          this.goToStep(2);
          this.openDrawer();
        }
      });
    }
    if (this.els.drawerClose) this.els.drawerClose.addEventListener('click', () => this.closeDrawer());
    if (this.els.drawerBackdrop) this.els.drawerBackdrop.addEventListener('click', () => this.closeDrawer());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeDrawer();
    });
    this.bindDrawerHandleDrag();
  }

  bindDrawerHandleDrag() {
    var handle = this.els.drawerHandle;
    var panel = this.els.summary;
    if (!handle || !panel) return;

    var startY = 0;
    var currentDelta = 0;
    var dragging = false;

    var onPointerMove = (e) => {
      if (!dragging) return;
      var delta = e.clientY - startY;
      if (delta < 0) delta = 0;
      currentDelta = delta;
      panel.style.transform = 'translateY(' + delta + 'px)';
    };

    var endDrag = () => {
      if (!dragging) return;
      dragging = false;
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', endDrag);
      document.removeEventListener('pointercancel', endDrag);

      panel.style.transition = '';
      var panelHeight = panel.getBoundingClientRect().height || 1;
      var shouldClose = currentDelta > Math.min(120, panelHeight * 0.25);

      if (shouldClose) {
        panel.style.transform = 'translateY(100%)';
        window.setTimeout(() => {
          this.closeDrawer();
          panel.style.transform = '';
        }, 260);
      } else {
        panel.style.transform = '';
      }
      currentDelta = 0;
    };

    handle.addEventListener('pointerdown', (e) => {
      if (!panel.classList.contains('is-open')) return;
      dragging = true;
      startY = e.clientY;
      currentDelta = 0;
      panel.style.transition = 'none';
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', endDrag);
      document.addEventListener('pointercancel', endDrag);
    });

    handle.addEventListener('click', () => this.closeDrawer());
  }

  load() {
    this.setState('loading');

    console.log('[skio-bundle-box] config', this.config);

    fetch(SKIO_BB_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productPlatformId: String(this.config.productPlatformId) }),
    })
      .then((res) => {
        console.log('[skio-bundle-box] response status', res.status);
        if (!res.ok) throw new Error('Skio request failed: ' + res.status);
        return res.json();
      })
      .then((raw) => {
        console.log('[skio-bundle-box] raw response', raw);
        var box = SkioBundleBox.normalizeBox(raw);
        console.log('[skio-bundle-box] normalized box', box);
        if (!box || !box.products.length) throw new Error('Empty or invalid dynamic box response');
        this.box = box;
        this.onLoaded();
      })
      .catch((err) => {
        console.error('[skio-bundle-box]', err);
        this.setState('error');
      });
  }

  setState(state) {
    if (this.els.loading) this.els.loading.hidden = state !== 'loading';
    if (this.els.error) this.els.error.hidden = state !== 'error';
    if (this.els.content) this.els.content.hidden = state !== 'content';
  }

  onLoaded() {
    if (this.els.summaryHeading) this.els.summaryHeading.textContent = this.strings().summaryHeading || 'Your bundle';
    if (this.els.mobileStatus) this.els.mobileStatus.hidden = false;

    this.renderTabs();
    this.renderGrid();
    this.renderUpsellsGrid();
    this.renderSummary();
    this.setState('content');
    SkioBundleBox.reinitLoox();
    this.fetchReviewData();

    if (this.box.upsells.length === 0 && this.els.continueBtn && this.els.checkoutBtn) {
      this.els.continueBtn.dataset.baseLabel = this.els.checkoutBtn.dataset.baseLabel || this.els.checkoutBtn.textContent;
      this.els.continueBtn.textContent = this.els.continueBtn.dataset.baseLabel;
    }
  }

  fetchReviewData() {
    var token = SKIO_BB_STOREFRONT_TOKEN;
    if (!token) return;

    var ids = Array.from(this.ratingEls.keys());
    if (!ids.length) return;
    var gids = ids.map((id) => 'gid://shopify/Product/' + id);

    var query =
      'query($ids:[ID!]!){nodes(ids:$ids){... on Product{id ' +
      'ratingMf:metafield(namespace:"loox",key:"avg_rating"){value} ' +
      'countMf:metafield(namespace:"loox",key:"num_reviews"){value}}}}';

    fetch('/api/2025-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query: query, variables: { ids: gids } }),
    })
      .then((res) => res.json())
      .then((json) => {
        console.log('[skio-bundle-box] review data (Storefront API)', json);
        if (json.errors) throw new Error(JSON.stringify(json.errors));
        var nodes = (json.data && json.data.nodes) || [];
        nodes.forEach((node) => {
          if (!node) return;
          var rating = node.ratingMf && Number(node.ratingMf.value);
          var count = node.countMf && Number(node.countMf.value);
          if (rating && count != null && !isNaN(count)) {
            this.applyReviewData(SkioBundleBox.gidToId(node.id), rating, count);
          }
        });
      })
      .catch((err) => {
        console.error('[skio-bundle-box] review data fetch failed — check the Storefront API ' +
          'token and that loox.avg_rating/loox.num_reviews have Storefront API access enabled', err);
      });
  }

  applyReviewData(productId, rating, count) {
    var wraps = this.ratingEls.get(productId);
    if (!wraps) return;
    var pct = Math.max(0, Math.min(100, (rating / 5) * 100));
    var label = rating + ' out of 5 stars, ' + count + ' review' + (count === 1 ? '' : 's');
    wraps.forEach((wrap) => {
      wrap.innerHTML =
        '<span class="skio-bb__rating-stars" style="--rating-pct:' + pct + '%"></span>' +
        '<span class="skio-bb__rating-count">(' + count + ')</span>';
      wrap.setAttribute('role', 'img');
      wrap.setAttribute('aria-label', label);
    });
  }

  renderTabs() {
    var container = this.els.tabs;
    if (!container) return;
    container.innerHTML = '';

    if (!this.box.categorized) {
      container.hidden = true;
      return;
    }
    container.hidden = false;

    var strings = this.strings();
    var allBtn = document.createElement('button');
    allBtn.type = 'button';
    allBtn.className = 'skio-bb__tab is-active';
    allBtn.textContent = strings.allTab || 'All';
    allBtn.dataset.category = 'all';
    container.appendChild(allBtn);

    this.box.categories.forEach((cat) => {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'skio-bb__tab';
      btn.textContent = cat.name === 'Other' ? strings.otherTab || 'Other' : cat.name;
      btn.dataset.category = cat.name;
      container.appendChild(btn);
    });

    container.querySelectorAll('.skio-bb__tab').forEach((btn) => {
      btn.addEventListener('click', () => {
        container.querySelectorAll('.skio-bb__tab').forEach((b) => {
          b.classList.toggle('is-active', b === btn);
        });
        var category = btn.dataset.category;
        this.els.grid.querySelectorAll('[data-skio-bb-category-block]').forEach((block) => {
          block.hidden = category !== 'all' && block.dataset.category !== category;
        });
      });
    });
  }

  renderGrid() {
    var grid = this.els.grid;
    grid.innerHTML = '';
    this.cardSyncers = [];

    if (this.box.categorized) {
      this.box.categories.forEach((cat) => {
        var block = document.createElement('div');
        block.className = 'skio-bb__category-block';
        block.setAttribute('data-skio-bb-category-block', '');
        block.dataset.category = cat.name;

        var heading = document.createElement('h2');
        heading.className = 'skio-bb__category-title';
        heading.textContent = cat.name;
        block.appendChild(heading);

        var list = document.createElement('div');
        list.className = 'skio-bb__grid-list';
        cat.products.forEach((product) => {
          list.appendChild(this.buildCard(product, false));
        });
        block.appendChild(list);

        grid.appendChild(block);
      });
    } else {
      var list = document.createElement('div');
      list.className = 'skio-bb__grid-list';
      this.box.products.forEach((product) => {
        list.appendChild(this.buildCard(product, false));
      });
      grid.appendChild(list);
    }
  }

  renderUpsellsGrid() {
    var grid = this.els.upsellsGrid;
    if (!grid) return;
    grid.innerHTML = '';
    this.upsellCardSyncers = [];

    if (!this.box.upsells.length) {
      grid.hidden = true;
      return;
    }
    grid.hidden = false;

    var list = document.createElement('div');
    list.className = 'skio-bb__grid-list';
    this.box.upsells.forEach((product) => {
      list.appendChild(this.buildCard(product, true));
    });
    grid.appendChild(list);
  }

  buildCard(product, isUpsell) {
    var strings = this.strings();
    var card = document.createElement('div');
    card.className = 'skio-bb__card';

    var media = document.createElement('div');
    media.className = 'skio-bb__card-media';
    var img = document.createElement('img');
    img.loading = 'lazy';
    img.alt = product.title;
    media.appendChild(img);

    var bestSellerIds = this.config.bestSellerProductIds || [];
    if (bestSellerIds.indexOf(product.productId) !== -1) {
      var badge = document.createElement('span');
      badge.className = 'skio-bb__card-badge';
      badge.textContent = strings.bestSeller || 'BEST SELLER';
      media.appendChild(badge);
    }

    card.appendChild(media);

    var body = document.createElement('div');
    body.className = 'skio-bb__card-body';

    var title = document.createElement('p');
    title.className = 'skio-bb__card-title';
    title.textContent = product.title;
    body.appendChild(title);

    var ratingWrap = document.createElement('div');
    ratingWrap.className = 'skio-bb__card-rating';
    var loox = document.createElement('div');
    loox.className = 'loox-rating';
    loox.setAttribute('data-id', product.productId);
    ratingWrap.appendChild(loox);
    body.appendChild(ratingWrap);
    if (!this.ratingEls.has(product.productId)) this.ratingEls.set(product.productId, []);
    this.ratingEls.get(product.productId).push(ratingWrap);

    var select = null;
    if (product.variants.length > 1) {
      select = document.createElement('select');
      select.className = 'skio-bb__card-variant';
      select.setAttribute('aria-label', product.title + ' option');
      product.variants.forEach((v) => {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        select.appendChild(opt);
      });
      body.appendChild(select);
    }

    var priceRow = document.createElement('p');
    priceRow.className = 'skio-bb__card-price';
    var priceEl = document.createElement('span');
    priceEl.className = 'skio-bb__card-price-current';
    var compareEl = document.createElement('span');
    compareEl.className = 'skio-bb__card-price-compare';
    priceRow.appendChild(compareEl);
    priceRow.appendChild(priceEl);
    body.appendChild(priceRow);

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'skio-bb__add-btn';
    addBtn.innerHTML =
      '<span class="skio-bb__add-btn-full">' +
      SkioBundleBox.escapeHtml(strings.addToBundle || 'ADD TO BUNDLE') +
      '</span><span class="skio-bb__add-btn-short">' +
      SkioBundleBox.escapeHtml(strings.addToBundleShort || 'ADD') +
      '</span>';
    body.appendChild(addBtn);

    var stepper = document.createElement('div');
    stepper.className = 'skio-bb__stepper';
    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'skio-bb__stepper-btn';
    minus.textContent = '−';
    minus.setAttribute('aria-label', (strings.decreaseQty || 'Decrease quantity of') + ' ' + product.title);
    var count = document.createElement('span');
    count.className = 'skio-bb__stepper-count';
    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'skio-bb__stepper-btn';
    plus.textContent = '+';
    plus.setAttribute('aria-label', (strings.increaseQty || 'Increase quantity of') + ' ' + product.title);
    stepper.appendChild(minus);
    stepper.appendChild(count);
    stepper.appendChild(plus);
    body.appendChild(stepper);

    card.appendChild(body);

    var currentVariant = () => {
      var id = select ? select.value : product.variants[0].id;
      var found = null;
      product.variants.forEach((v) => {
        if (v.id === id) found = v;
      });
      return found || product.variants[0];
    };

    var map = isUpsell ? this.upsellSelection : this.selection;

    var sync = () => {
      var v = currentVariant();
      img.src = v.image || product.fallbackImage || '';
      priceEl.textContent = SkioBundleBox.formatMoney(this.finalUnitPrice(v, isUpsell));
      if (this.subscribe && !isUpsell) {
        compareEl.textContent = SkioBundleBox.formatMoney(v.price);
        compareEl.hidden = false;
        compareEl.classList.add('is-subscribe-compare');
      } else if (v.compareAtPrice > v.price) {
        compareEl.textContent = SkioBundleBox.formatMoney(v.compareAtPrice);
        compareEl.hidden = false;
        compareEl.classList.remove('is-subscribe-compare');
      } else {
        compareEl.hidden = true;
        compareEl.classList.remove('is-subscribe-compare');
      }
      var entry = map.get(v.id);
      var qty = entry ? entry.qty : 0;
      count.textContent = qty;
      minus.disabled = qty === 0;
      var atMax = !isUpsell && this.box.sizeMax != null && this.totalBoxQty() >= this.box.sizeMax;
      plus.disabled = atMax;
      addBtn.hidden = qty > 0;
      addBtn.disabled = atMax;
      stepper.hidden = qty === 0;
    };

    (isUpsell ? this.upsellCardSyncers : this.cardSyncers).push(sync);

    addBtn.addEventListener('click', () => this.changeQty(product, currentVariant(), 1, isUpsell));
    minus.addEventListener('click', () => this.changeQty(product, currentVariant(), -1, isUpsell));
    plus.addEventListener('click', () => this.changeQty(product, currentVariant(), 1, isUpsell));
    if (select) select.addEventListener('change', sync);

    sync();
    return card;
  }

  changeQty(product, variant, delta, isUpsell) {
    var map = isUpsell ? this.upsellSelection : this.selection;

    if (delta > 0 && !isUpsell && this.box.sizeMax != null && this.totalBoxQty() >= this.box.sizeMax) {
      return;
    }

    var entry = map.get(variant.id);
    var qty = (entry ? entry.qty : 0) + delta;

    if (qty <= 0) {
      map.delete(variant.id);
    } else {
      map.set(variant.id, { qty: qty, variant: variant, product: product });
    }

    this.renderSummary();
    this.syncAllCards();
  }

  syncAllCards() {
    this.cardSyncers.forEach((fn) => fn());
    this.upsellCardSyncers.forEach((fn) => fn());
  }

  totalBoxQty() {
    var total = 0;
    this.selection.forEach((e) => {
      total += e.qty;
    });
    return total;
  }

  currentTierPercent() {
    var qty = this.totalBoxQty();
    var percent = 0;
    (this.box.tiers || []).forEach((t) => {
      if (qty >= t.qty) percent = t.percent;
    });
    return percent;
  }

  nextTier() {
    var qty = this.totalBoxQty();
    var next = null;
    (this.box.tiers || []).forEach((t) => {
      if (qty < t.qty && (next === null || t.qty < next.qty)) next = t;
    });
    return next;
  }

  selectedPlan() {
    if (!this.box.sellingPlans.length) return null;
    var found = null;
    this.box.sellingPlans.forEach((p) => {
      if (p.groupId === this.selectedPlanGroupId) found = p;
    });
    return found || this.box.sellingPlans[0];
  }

  finalUnitPrice(variant, isUpsell) {
    if (isUpsell) return variant.price;

    var tierPercent = this.currentTierPercent();
    var base = variant.price;

    if (this.subscribe) {
      var plan = this.selectedPlan();
      var mapping = plan && plan.variantMapping[variant.id];
      if (mapping) base = mapping.adjustedPrice;
    }

    return SkioBundleBox.applyPercentOff(base, tierPercent);
  }

  getTotals() {
    var subtotal = 0;
    var afterTier = 0;
    var boxTotal = 0;
    var tierPercent = this.currentTierPercent();

    this.selection.forEach((entry) => {
      var base = entry.variant.price;
      subtotal += base * entry.qty;
      var tierUnit = SkioBundleBox.applyPercentOff(base, tierPercent);
      afterTier += tierUnit * entry.qty;
      boxTotal += this.finalUnitPrice(entry.variant, false) * entry.qty;
    });

    var upsellsTotal = 0;
    this.upsellSelection.forEach((entry) => {
      upsellsTotal += entry.variant.price * entry.qty;
    });

    var bundleSavings = subtotal - afterTier;
    var subscribeSavings = afterTier - boxTotal;
    var subscribePercent = this.subscribe && afterTier > 0 ? Math.round((subscribeSavings / afterTier) * 100) : 0;

    return {
      qty: this.totalBoxQty(),
      subtotal: subtotal,
      tierPercent: tierPercent,
      bundleSavings: bundleSavings,
      subscribePercent: subscribePercent,
      subscribeSavings: subscribeSavings,
      discount: bundleSavings + subscribeSavings,
      boxTotal: boxTotal,
      upsellsTotal: upsellsTotal,
      grandTotal: boxTotal + upsellsTotal,
    };
  }

  renderSummary() {
    this.renderScale();
    this.renderTierMessage();
    this.renderSubscription(); // may reset this.subscribe — must run before anything pricing off it
    this.renderFreeShipping();
    this.renderCartItems();
    this.renderTotals();
    this.updateProgressAndButtons();
    this.renderMobileBar();
  }

  renderScale() {
    if (!this.els.scales.length) return;
    var qty = this.totalBoxQty();
    var html = '';
    this.box.tiers.forEach((t, i) => {
      if (i > 0) html += '<div class="skio-bb__tier-seg"></div>';
      html +=
        '<div class="skio-bb__tier' +
        (qty >= t.qty ? ' is-active' : '') +
        '">' +
        '<div class="skio-bb__tier-circle">' +
        SkioBundleBox.escapeHtml(String(t.qty)) +
        '</div>' +
        '<span class="skio-bb__tier-label">' +
        SkioBundleBox.escapeHtml(t.percent + '% off') +
        '</span></div>';
    });
    this.els.scales.forEach((container) => {
      container.innerHTML = html;
    });
  }

  renderTierMessage() {
    if (!this.els.tierMessages.length) return;
    var next = this.nextTier();
    var text = '';
    var hidden = true;
    if (next) {
      var needed = next.qty - this.totalBoxQty();
      var strings = this.strings();
      text = SkioBundleBox.fillTemplate(strings.tierProgress || 'Add [n] more [product] to save [percent]%', {
        n: needed,
        product: needed === 1 ? 'product' : 'products',
        percent: next.percent,
      });
      hidden = false;
    }
    this.els.tierMessages.forEach((el) => {
      el.textContent = text;
      el.hidden = hidden;
    });
  }

  renderFreeShipping() {
    if (!this.els.freeShippings.length) return;
    var threshold = Number(this.config.freeShippingThreshold) || 0;
    if (threshold <= 0) {
      this.els.freeShippings.forEach((container) => {
        container.hidden = true;
        container.innerHTML = '';
      });
      return;
    }

    var totals = this.getTotals();
    var current = totals.boxTotal + totals.upsellsTotal;
    var unlocked = current >= threshold;
    var pct = Math.max(0, Math.min(100, (current / threshold) * 100));
    var strings = this.strings();
    var message = unlocked
      ? strings.freeShippingUnlocked || "You've unlocked free shipping"
      : SkioBundleBox.fillTemplate(strings.freeShippingProgress || 'Add [amount] more for free shipping', {
          amount: SkioBundleBox.formatMoney(threshold - current),
        });

    var html =
      '<div class="skio-bb__fs-row' +
      (unlocked ? ' is-unlocked' : '') +
      '">' +
      (unlocked ? '<span class="skio-bb__fs-check">&#10003;</span>' : '') +
      '<span>' +
      SkioBundleBox.escapeHtml(message) +
      '</span></div>' +
      '<div class="skio-bb__fs-track"><div class="skio-bb__fs-fill" style="width:' +
      pct +
      '%"></div></div>';

    this.els.freeShippings.forEach((container) => {
      container.hidden = false;
      container.innerHTML = html;
    });
  }

  renderCartItems() {
    var container = this.els.cartItems;
    if (!container) return;
    container.innerHTML = '';

    var hasItems = this.selection.size > 0 || this.upsellSelection.size > 0;
    if (this.els.itemsDivider) this.els.itemsDivider.hidden = !hasItems;

    var row = (entry, isUpsell) => {
      var line = document.createElement('div');
      line.className = 'skio-bb__cart-item';

      var img = document.createElement('img');
      img.src = entry.variant.image || entry.product.fallbackImage || '';
      img.alt = entry.product.title;
      line.appendChild(img);

      var info = document.createElement('div');
      info.className = 'skio-bb__cart-item-info';
      var title = document.createElement('p');
      title.className = 'skio-bb__cart-item-title';
      var hasRealVariantTitle = entry.variant.title && entry.variant.title !== 'Default Title';
      title.textContent = hasRealVariantTitle ? entry.product.title + ' — ' + entry.variant.title : entry.product.title;
      var qtyLine = document.createElement('p');
      qtyLine.className = 'skio-bb__cart-item-qty';
      qtyLine.textContent = 'Qty ' + entry.qty;
      info.appendChild(title);
      info.appendChild(qtyLine);
      line.appendChild(info);

      var priceEl = document.createElement('span');
      priceEl.className = 'skio-bb__cart-item-price';
      priceEl.textContent = SkioBundleBox.formatMoney(this.finalUnitPrice(entry.variant, isUpsell) * entry.qty);
      line.appendChild(priceEl);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'skio-bb__cart-item-remove';
      removeBtn.setAttribute('aria-label', (this.strings().remove || 'Remove') + ' ' + entry.product.title);
      removeBtn.innerHTML = '&times;';
      removeBtn.addEventListener('click', () => this.changeQty(entry.product, entry.variant, -entry.qty, isUpsell));
      line.appendChild(removeBtn);

      return line;
    };

    this.selection.forEach((entry) => container.appendChild(row(entry, false)));
    this.upsellSelection.forEach((entry) => container.appendChild(row(entry, true)));
  }

  renderSubscription() {
    var container = this.els.subscription;
    if (!container) return;

    if (!this.box.sellingPlans.length) {
      container.hidden = true;
      container.innerHTML = '';
      this.subscribe = false;
      return;
    }

    if (this.totalBoxQty() < this.box.sizeMin) {
      container.hidden = true;
      container.innerHTML = '';
      return;
    }
    container.hidden = false;

    var strings = this.strings();
    var plan = this.selectedPlan();
    var planPercent = plan && plan.priceAdjustmentType === 'PERCENTAGE' ? plan.priceAdjustmentAmount : 0;
    var subscribeLabel = SkioBundleBox.fillTemplate(strings.subscribe || 'Subscribe & save an extra [percent]%', {
      percent: planPercent,
    });
    var benefits = [strings.subscribeBenefit1, strings.subscribeBenefit2, strings.subscribeBenefit3]
      .filter(Boolean)
      .map(function (text) {
        return (
          '<div class="skio-bb__subscribe-benefit"><span class="skio-bb__subscribe-check">&#10003;</span><span>' +
          SkioBundleBox.escapeHtml(text) +
          '</span></div>'
        );
      })
      .join('');

    container.innerHTML =
      '<label class="skio-bb__subscribe-option">' +
      '<input type="radio" name="skio-bb-purchase-type-' +
      this.box.boxId +
      '" data-skio-bb-subscribe-radio' +
      (this.subscribe ? ' checked' : '') +
      '>' +
      '<span class="skio-bb__subscribe-option-label">' +
      SkioBundleBox.escapeHtml(subscribeLabel) +
      '</span>' +
      '</label>' +
      '<div class="skio-bb__subscribe-benefits">' +
      benefits +
      '</div>' +
      '<label class="skio-bb__onetime-option">' +
      '<input type="radio" name="skio-bb-purchase-type-' +
      this.box.boxId +
      '" data-skio-bb-onetime-radio' +
      (!this.subscribe ? ' checked' : '') +
      '>' +
      '<span>' +
      SkioBundleBox.escapeHtml(strings.oneTimePurchase || 'One-time purchase') +
      '</span>' +
      '</label>';

    var subRadio = container.querySelector('[data-skio-bb-subscribe-radio]');
    var oneRadio = container.querySelector('[data-skio-bb-onetime-radio]');
    if (subRadio) {
      subRadio.addEventListener('change', () => {
        this.subscribe = true;
        this.renderSummary();
        this.syncAllCards();
      });
    }
    if (oneRadio) {
      oneRadio.addEventListener('change', () => {
        this.subscribe = false;
        this.renderSummary();
        this.syncAllCards();
      });
    }
  }

  renderTotals() {
    var container = this.els.totals;
    if (!container) return;
    var strings = this.strings();
    var totals = this.getTotals();

    if (totals.qty === 0 && this.upsellSelection.size === 0) {
      container.hidden = true;
      return;
    }
    container.hidden = false;

    var rows =
      '<div class="skio-bb__totals-row"><span>' +
      SkioBundleBox.escapeHtml(strings.subtotal || 'Subtotal') +
      '</span><span>' +
      SkioBundleBox.formatMoney(totals.subtotal + totals.upsellsTotal) +
      '</span></div>';

    if (totals.bundleSavings > 0) {
      rows +=
        '<div class="skio-bb__totals-row skio-bb__totals-row--discount"><span>' +
        SkioBundleBox.escapeHtml(
          SkioBundleBox.fillTemplate(strings.bundleSavings || 'Bundle savings ([percent]%)', { percent: totals.tierPercent })
        ) +
        '</span><span>−' +
        SkioBundleBox.formatMoney(totals.bundleSavings) +
        '</span></div>';
    }

    if (totals.subscribeSavings > 0) {
      rows +=
        '<div class="skio-bb__totals-row skio-bb__totals-row--discount"><span>' +
        SkioBundleBox.escapeHtml(
          SkioBundleBox.fillTemplate(strings.subscribeSavings || 'Subscribe & save ([percent]%)', {
            percent: totals.subscribePercent,
          })
        ) +
        '</span><span>−' +
        SkioBundleBox.formatMoney(totals.subscribeSavings) +
        '</span></div>';
    }

    rows +=
      '<div class="skio-bb__totals-row skio-bb__totals-row--total"><span>' +
      SkioBundleBox.escapeHtml(strings.total || 'Total') +
      '</span><span>' +
      SkioBundleBox.formatMoney(totals.grandTotal) +
      '</span></div>';

    if (totals.discount > 0) {
      rows +=
        '<div class="skio-bb__totals-row skio-bb__totals-row--saved"><span>' +
        SkioBundleBox.escapeHtml(strings.youSaved || 'You saved') +
        '</span><span>' +
        SkioBundleBox.formatMoney(totals.discount) +
        '</span></div>';
    }

    container.innerHTML = rows;
  }

  updateActionLabel(btn, showSaveSuffix) {
    if (!btn) return;
    if (showSaveSuffix == null) showSaveSuffix = true;
    if (btn.dataset.baseLabel == null) btn.dataset.baseLabel = btn.textContent;
    var strings = this.strings();
    var totals = this.getTotals();
    var needed = this.box.sizeMin - totals.qty;

    if (needed > 0) {
      btn.textContent = SkioBundleBox.fillTemplate(strings.addMoreToContinue || 'Add [n] more to continue', { n: needed });
    } else if (showSaveSuffix && totals.discount > 0) {
      btn.textContent = SkioBundleBox.fillTemplate(strings.checkoutSave || '[base] · SAVE [amount]', {
        base: btn.dataset.baseLabel,
        amount: SkioBundleBox.formatMoney(totals.discount),
      });
    } else {
      btn.textContent = btn.dataset.baseLabel;
    }
  }

  updateProgressAndButtons() {
    var totals = this.getTotals();
    var qty = totals.qty;
    var meetsMin = qty >= this.box.sizeMin;

    if (this.els.continueBtn) {
      this.els.continueBtn.disabled = !meetsMin;
      this.els.continueBtn.hidden = this.step !== 1 || qty === 0;
      this.updateActionLabel(this.els.continueBtn);
    }

    if (this.els.checkoutBtn) {
      this.els.checkoutBtn.disabled = !meetsMin;
      this.updateActionLabel(this.els.checkoutBtn);
    }
  }

  renderMobileBar() {
    var bar = this.els.mobileBar;
    if (!bar) return;
    var totals = this.getTotals();

    if (totals.qty === 0) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;

    if (this.els.mobileBarProgress) {
      var tierText = this.els.tierMessages[0] ? this.els.tierMessages[0].textContent : '';
      this.els.mobileBarProgress.textContent = tierText;
      this.els.mobileBarProgress.hidden = !tierText;
    }

    if (this.els.mobileBarMeta) {
      var itemWord = totals.qty === 1 ? 'item' : 'items';
      var html = '<strong>' + totals.qty + ' ' + itemWord + '</strong>';
      if (totals.discount > 0) {
        html += ' <span class="skio-bb__mobile-bar-save">Save ' + SkioBundleBox.formatMoney(totals.discount) + '</span>';
      }
      this.els.mobileBarMeta.innerHTML = html;
    }

    if (this.els.mobileBarTotal) {
      this.els.mobileBarTotal.textContent =
        (this.strings().total || 'Total') + '  ' + SkioBundleBox.formatMoney(totals.grandTotal);
    }

    if (this.els.mobileBarCheckout) {
      this.els.mobileBarCheckout.disabled = totals.qty < this.box.sizeMin;
      this.updateActionLabel(this.els.mobileBarCheckout, false);
    }
  }

  openDrawer() {
    if (!this.els.summary || this.els.summary.classList.contains('is-open')) return;
    this.els.summary.classList.add('is-open');
    this.els.summary.setAttribute('role', 'dialog');
    this.els.summary.setAttribute('aria-modal', 'true');
    if (this.els.drawerBackdrop) this.els.drawerBackdrop.hidden = false;
    document.body.classList.add('skio-bb-drawer-open');
    if (this.els.summaryHeading) this.els.summaryHeading.focus();
  }

  closeDrawer() {
    if (!this.els.summary || !this.els.summary.classList.contains('is-open')) return;
    this.els.summary.classList.remove('is-open');
    this.els.summary.removeAttribute('role');
    this.els.summary.removeAttribute('aria-modal');
    if (this.els.drawerBackdrop) this.els.drawerBackdrop.hidden = true;
    document.body.classList.remove('skio-bb-drawer-open');
    if (this.els.mobileBarOpen) this.els.mobileBarOpen.focus();
  }

  goToStep(step) {
    this.step = step;
    this.root.setAttribute('data-step', String(step));
    if (this.els.panel1) this.els.panel1.hidden = step !== 1;
    if (this.els.panel2) this.els.panel2.hidden = step !== 2;
    if (this.els.tabs && this.box.categorized) this.els.tabs.hidden = step !== 1;
    if (this.els.backBtn) this.els.backBtn.hidden = step !== 2;
    if (this.els.checkoutBtn) this.els.checkoutBtn.hidden = step !== 2;

    this.updateProgressAndButtons();

    var panel = step === 1 ? this.els.panel1 : this.els.panel2;
    if (panel) {
      panel.setAttribute('tabindex', '-1');
      panel.focus();
    }
  }

  getSellingPlanIdFor(variantId) {
    if (!this.subscribe) return null;
    var plan = this.selectedPlan();
    var mapping = plan && plan.variantMapping[variantId];
    return mapping ? mapping.planId : null;
  }

  buildCartItems(boxIndex) {
    var items = [];

    this.selection.forEach((entry, variantId) => {
      var item = {
        id: Number(variantId),
        quantity: entry.qty,
        properties: { _dynamicBoxId: this.box.boxId, _dynamicBoxIndex: boxIndex },
      };
      var sellingPlanId = this.getSellingPlanIdFor(variantId);
      if (sellingPlanId) item.selling_plan = Number(sellingPlanId);
      items.push(item);
    });

    this.upsellSelection.forEach((entry, variantId) => {
      items.push({ id: Number(variantId), quantity: entry.qty });
    });

    return items;
  }

  nextBoxIndex() {
    return fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        var existing = (cart.items || [])
          .map((item) => item.properties && Number(item.properties._dynamicBoxIndex))
          .filter((n) => !isNaN(n));
        return existing.length ? Math.max.apply(null, existing) + 1 : 0;
      })
      .catch(() => 0);
  }

  checkout() {
    if (this.els.checkoutBtn.disabled) return;

    if (this.totalBoxQty() < this.box.sizeMin) {
      this.updateProgressAndButtons();
      return;
    }

    this.els.checkoutBtn.disabled = true;
    if (this.els.mobileBarCheckout) this.els.mobileBarCheckout.disabled = true;
    if (this.els.cartError) this.els.cartError.hidden = true;

    this.nextBoxIndex()
      .then((boxIndex) => {
        var items = this.buildCartItems(boxIndex);
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        }).then((res) =>
          res.json().then((json) => {
            if (!res.ok) throw new Error(json.description || 'cart add failed');
            return json;
          })
        );
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch((err) => {
        console.error('[skio-bundle-box]', err);
        this.els.checkoutBtn.disabled = false;
        if (this.els.mobileBarCheckout) this.els.mobileBarCheckout.disabled = false;
        if (this.els.cartError) {
          this.els.cartError.hidden = false;
          this.els.cartError.textContent =
            this.strings().addToCartError || 'Something went wrong adding your bundle to the cart. Please try again.';
        }
      });
  }
}

function initAllSkioBundleBoxes(scope) {
  (scope || document).querySelectorAll('[data-skio-bb]').forEach((root) => {
    new SkioBundleBox(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllSkioBundleBoxes());
} else {
  initAllSkioBundleBoxes();
}

document.addEventListener('shopify:section:load', (evt) => initAllSkioBundleBoxes(evt.target));
